import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const ResourcesView = angular
  .module('acme.view.application.resources', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.resources.controllers',
    'acme.view.application.resources.create',
    'acme.view.application.resources.edit',
    'acme.view.application.resources.detail',
    'acme.view.application.resources.requests',
    'acme.view.application.resources.personnel',
    'acme.view.application.resources.facilities',
    'acme.view.application.resources.equipment',
    'acme.view.application.resources.instances',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const resources = {
      name: 'application.resources',
      url: '/resources',
      abstract: true,
      views: {
        'subview-main': {
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/resources/resources.tpl.html',
        },
      },
      data: {
        pageTitle: 'Resources',
        roles: ['admin'],
      },
    };

    const resourcesList = {
      name: 'application.resources.list',
      url: '',
      views: {
        'subview-main': {
          controller: 'ResourcesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/resources/resourcesList.tpl.html',
        },
      },
      data: {
        pageTitle: 'Resources Templates',
        rule: function (permits) {
          // Allow if state is not in exclusions array
          return permits.indexOf('application.resources.list') !== -1;
        },
      },
    };

    $stateProvider.state(resources).state(resourcesList);
  }).name;
